export default {
  'channelPartner.title': 'Socios',
  'channelPartner.description': 'Registra entidades partner y asigna propiedad comercial.',

  'channelPartner.fields.distributorId': 'Distribuidor',
};
